<template>
  <div class="main-container flex flex-center">
    <div class="main-box" style="overflow: hidden">
      <!--头部导航-->
      <div class="box-header flex flex-center">
        <div class="box-header-left flex flex-center">
          <span
            class="header-span"
            :class="{ 'header-span-active': active == 1 }"
            @click="changeTab1(1)"
            >{{ $t("m.options.listTab.time") }}</span
          >
          <span
            class="header-span"
            :class="{ 'header-span-active': active == 2 }"
            @click="changeTab1(2)"
            >{{ $t("m.options.listTab.name") }}</span
          >
          <span
            class="header-span"
            :class="{ 'header-span-active': active == 3 }"
            @click="changeTab1(3)"
            >{{ $t("m.options.listTab.inventory") }}</span
          >
        </div>
        <div class="box-header-right">
          <el-button
            type="primary"
            icon="el-icon-search"
            class="active-icon"
            @click="dialogTableVisible = true"
          ></el-button>
          <el-button
            type="primary"
            icon="el-icon-plus"
            class="active-icon"
            @click="createBean"
            >{{ $t("m.options.listTab.new") }}</el-button
          >
        </div>
      </div>
      <!--内容-->
      <div style="height: calc(100% - 55px);">
        <div
          class="box-content"
          style="max-height:calc(100% - 83px);"
        >
          <div
            @click="checkDevice(item)"
            :class="[
              item.id == activeBeanId
                ? 'box-item box-half box-active'
                : 'box-item box-half',
            ]"
            v-for="item in beanList"
            v-bind:key="item.id"
          >
            <div class="box-item-img">
              <img
                v-if="item.id == activeBeanId"
                src="../../assets/img/咖啡豆@2x.png"
              />
              <img v-else src="../../assets/img/咖啡豆@2x(1).png" />
              <div class="datetime">
                {{ $moment(Number(item.createtime)).format("YYYY-MM-DD") }}
              </div>
            </div>
            <div class="box-item-text">
              <div>
                <span class="text-title"
                  >{{ $t("m.deviceManage.deviceDetial.cfName") }}：</span
                >
                <span class="text-value">{{ item.name }}</span>
              </div>
              <div>
                <span class="text-title"
                  >{{ $t("m.deviceManage.deviceDetial.cfLevel") }}：</span
                ><span class="text-value">{{ item.level }}</span>
              </div>
              <div>
                <span class="text-title"
                  >{{ $t("m.deviceManage.deviceDetial.cfOpreate2") }}：</span
                ><span class="text-value">{{ item.method }}</span>
              </div>
              <div>
                <span class="text-title"
                  >{{ $t("m.deviceManage.deviceDetial.cfWeight")
                  }}{{ weight }}：</span
                ><span class="text-value">{{ item.stock }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="table-footer">
          <el-pagination
              v-show="beanPage.total > 0"
              background
              align="right"
              layout="prev, pager, next"
              @current-change="storagePageChange"
              :page-size="beanPage.pageSize"
              :total="beanPage.total"
          >
          </el-pagination>
        </div>
      </div>
      <div class="main-box-footer">
        <span
          >{{ $t("m.deviceManage.deviceDetial.cfAllWeight") }}：{{
            beanAllWeight
          }}{{ weight }} | {{ $t("m.deviceManage.deviceDetial.kind") }}：{{
            beanKindCount
          }}{{ $t("m.deviceManage.deviceDetial.kind2") }}</span
        >
      </div>
    </div>
    <div class="main-box border-1px-all">
      <bean-detail
        v-if="refreshBeanDetail"
        :beanInfo="selectBean"
        :show-report-list="showReportList"
        :isAdd="isAdd"
      ></bean-detail>
    </div>
    <!--------搜索弹框---------->
    <el-dialog
      :title="$t('m.chart.table.search')"
      :visible.sync="dialogTableVisible"
      width="500px"
      :show-close="false"
    >
      <div>
        <el-select
          v-model="searchParamKey"
          style="width: 220px;"
          placeholder=""
        >
          <!--                        <el-option-->
          <!--                                v-for="item in searchParamsKeyOptions"-->
          <!--                                :key="item.value"-->
          <!--                                :label="item.label"-->
          <!--                                :value="item.value">-->
          <!--                        </el-option>-->
          <el-option
            :key="searchParamsKeyOptions[0].value"
            :label="$t('m.options.beanSearchOptions.name')"
            :value="searchParamsKeyOptions[0].value"
          >
          </el-option>
          <el-option
            :key="searchParamsKeyOptions[1].value"
            :label="$t('m.options.beanSearchOptions.supply')"
            :value="searchParamsKeyOptions[1].value"
          >
          </el-option>
        </el-select>
        <div class="flex flex-center flex-between" style="margin-bottom:10px;">
          <el-input
            v-model="searchParamValue"
            style="width: 220px;"
            :placeholder="$t('m.chart.table.placeholder3')"
          ></el-input>
        </div>
      </div>
      <div slot="footer" class="flex flex-center">
        <div @click="dialogTableVisible = false" class="dialog-footer-btn">
          {{ $t("m.chart.table.cancel") }}
        </div>
        <div type="primary" @click="searchClick" class="dialog-footer-btn">
          {{ $t("m.chart.table.confirm") }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//import beanDetail from '@/components/bean/beanDetail'
import beanDetail from "@/components-online/storage/beanDetail";

export default {
  name: "storageStatus",
  components: {
    "bean-detail": beanDetail,
  },
  data() {
    return {
      weight: "kg",
      isAdd: false,
      beanList: [],
      beanPage: {
        pageSize: 20,
        pageNum: 1,
        total: 0,
      },
      beanKindCount: 0,
      beanAllWeight: 0,
      hasSearchParams: false,
      url: "/manage/bean/list.do",
      searchParamValue: "", //搜索框输入的值
      searchParamKey: "name",
      searchParamsKeyOptions: [
        { value: "name", label: "生豆名称" },
        { value: "supply", label: "供应商" },
      ],
      orderParamValue: "", //搜索框输入的值
      orderParamKey: "/manage/bean/listByName.do",
      orderParamsKeyOptions: [
        { value: "/manage/bean/listByName.do", label: "首字母" },
        { value: "/manage/bean/listByStock.do", label: "库存" },
        { value: "/manage/bean/listByTime.do", label: "创建时间" },
      ],
      beanCountUrl: "/manage/bean/count.do",
      beanDetailDialog: false,
      selectBean: {},
      showReportList: false,
      refreshBeanDetail: true,
      selectBeanIds: [],
      activeBeanId: 0,
      loading: undefined,

      active: 1,
      active1: 1,
      bean: "",
      deal: "",
      level: "",
      season: "",
      name: "",
      date: "",
      selectValue: "",
      sliderValue: 30,
      num1: 3,
      num2: 0,
      num3: 0,
      dialogTableVisible: false,
      dialogTableVisible2: false,
    };
  },
  mounted() {
    this.weight = "(" + localStorage.weight + ")";
    this.getBeanList();
    this.getBeanCountInfo();
  },
  methods: {
    createBean() {
      this.isAdd = true;
      this.showReportList = false;
      this.selectBean = {};
      this.refreshBeanDetail = false;
      // 在组件移除后，重新渲染组件
      // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
      this.$nextTick(() => {
        this.refreshBeanDetail = true;
      });
    },
    getBeanList() {
      this.$http
        .get(this.url, {
          params: {
            pageNum: this.beanPage.pageNum,
            pageSize: this.beanPage.pageSize,
          },
        })
        .then(
          function(resp) {
            this.beanList = resp.data.data.list;
            this.beanPage.total = resp.data.data.total;

            if (this.weight == "(g)") {
              for (let index in this.beanList) {
                this.beanList[index].stock = this.weightTrans(
                  this.beanList[index].stock
                );
              }
            }

            this.activeBeanId = resp.data.data.list[0].id;

            this.selectBean = this.beanList[0];
            this.selectBean.owner = -1;
            this.showReportList = true;
            this.refreshBeanDetail = false;
            this.isAdd = false;
            // 在组件移除后，重新渲染组件
            // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
            this.$nextTick(() => {
              this.refreshBeanDetail = true;
            });
            this.beanDetailDialog = true;
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    getBeanCountInfo() {
      let url = this.beanCountUrl;
      this.$http
        .get(url)
        .then(
          function(resp) {
            console.info(resp);
            this.beanKindCount = resp.data.data.kinds;
            this.beanAllWeight = resp.data.data.stockSum;
            if (this.weight == "(g)") {
              this.beanAllWeight = this.weightTrans(this.beanAllWeight);
            }
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    dateFormat(row, column) {
      var date = row[column.property];
      if (date == undefined) {
        return "";
      }
      //.replace(/年|月/g, "-").replace(/日/g, " ")
      return this.$moment(date).format("YYYY-MM-DD");
    },
    changeTab1(tab) {
      console.info("获取豆子列表");
      var url = "/manage/bean/listByTime.do";
      var active = 1;
      var sort = 1;
      if (tab == 1) {
        url = "/manage/bean/listByTime.do";
        active = 1;
        sort = 2;
      } else if (tab == 2) {
        url = "/manage/bean/listByName.do";
        active = 2;
      } else if (tab == 3) {
        url = "/manage/bean/listByStock.do";
        active = 3;
        sort = 2;
      }
      this.$http
        .get(url, {
          params: {
            pageNum: this.beanPage.pageNum,
            pageSize: this.beanPage.pageSize,
            sort: sort,
          },
        })
        .then(
          function(resp) {
            this.beanList = resp.data.data.list;
            this.beanPage.total = resp.data.data.total;

            if (this.weight == "(g)") {
              for (let index in this.beanList) {
                this.beanList[index].stock = this.weightTrans(
                  this.beanList[index].stock
                );
              }
            }

            const loading = this.$loading({
              lock: true,
              text: "Loading",
              spinner: "el-icon-loading",
               background: "rgba(0, 0, 0, 0.7)",
            });
            this.loading = loading;
            this.activeBeanId = resp.data.data.list[0].id;
            setTimeout(() => {
              loading.close();
            }, 2000);
            this.active = active;

            //console.info(resp.data.data.list[0])
            this.selectBean = this.beanList[0];
            this.selectBean.owner = -1;
            this.showReportList = true;
            this.isAdd = false;
            this.refreshBeanDetail = false;
            // 在组件移除后，重新渲染组件
            // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
            this.$nextTick(() => {
              this.refreshBeanDetail = true;
            });
            this.beanDetailDialog = true;
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    weightTrans(val) {
      //把kg转换成g
      return val * 1000;
    },
    searchClick() {
      var active = 0;
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
         background: "rgba(0, 0, 0, 0.7)",
      });
      this.loading = loading;
      if (this.searchParamKey == "supply") {
        let params = {
          pageNum: this.beanPage.pageNum,
          pageSizez: this.beanPage.pageSize,
          supply: this.searchParamValue,
        };
        if (
          this.searchParamValue.trim().length > 0 &&
          this.searchParamValue != null
        ) {
          this.$http
            .get("/manage/bean/searchBySupply.do", { params: params })
            .then(
              function(resp) {
                if (resp.data.success) {
                  this.beanList = resp.data.data.list;
                  this.beanPage.total = resp.data.data.total;

                  if (this.weight == "(g)") {
                    for (let index in this.beanList) {
                      this.beanList[index].stock = this.weightTrans(
                        this.beanList[index].stock
                      );
                    }
                  }

                  this.activeBeanId = resp.data.data.list[0].id;
                  console.info(resp.data.data.list[0]);
                  this.selectBean = this.beanList[0];
                  this.selectBean.owner = -1;
                  this.showReportList = true;
                  this.isAdd = false;
                  this.refreshBeanDetail = false;
                  // 在组件移除后，重新渲染组件
                  // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
                  this.$nextTick(() => {
                    this.refreshBeanDetail = true;
                  });
                  this.beanDetailDialog = true;
                }
              }.bind(this)
            )
            .catch((err) => err);
        } else {
          this.getBeanList();
        }
      } else {
        let params = {
          pageNum: this.beanPage.pageNum,
          pageSizez: this.beanPage.pageSize,
          keyword: this.searchParamValue,
        };
        if (
          this.searchParamValue.trim().length > 0 &&
          this.searchParamValue != null
        ) {
          this.$http
            .get("/manage/bean/searchByName.do", { params: params })
            .then(
              function(resp) {
                if (resp.data.success) {
                  this.beanList = resp.data.data.list;
                  this.beanPage.total = resp.data.data.total;

                  if (this.weight == "(g)") {
                    for (let index in this.beanList) {
                      this.beanList[index].stock = this.weightTrans(
                        this.beanList[index].stock
                      );
                    }
                  }

                  this.activeBeanId = resp.data.data.list[0].id;
                  console.info(resp.data.data.list[0]);
                  this.selectBean = this.beanList[0];
                  this.selectBean.owner = -1;
                  this.showReportList = true;
                  this.isAdd = false;
                  this.refreshBeanDetail = false;
                  // 在组件移除后，重新渲染组件
                  // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
                  this.$nextTick(() => {
                    this.refreshBeanDetail = true;
                  });
                  this.beanDetailDialog = true;
                }
              }.bind(this)
            )
            .catch((err) => err);
        } else {
          this.getBeanList();
        }
      }
      this.active = active;
      this.dialogTableVisible = false;
      loading.close();
    },
    checkDevice(item) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
         background: "rgba(0, 0, 0, 0.7)",
      });
      this.loading = loading;
      this.activeBeanId = item.id;
      setTimeout(() => {
        loading.close();
      }, 2000);

      console.info(item);
      this.selectBean = item;
      this.selectBean.owner = -1;
      this.showReportList = true;
      this.refreshBeanDetail = false;
      this.isAdd = false;
      // 在组件移除后，重新渲染组件
      // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
      this.$nextTick(() => {
        this.refreshBeanDetail = true;
      });
      this.beanDetailDialog = true;
    },
    storagePageChange(val) {
      console.info(val);
      this.beanPage.pageNum = val;
      this.changeTab1(this.active1);
    },
  },
};
</script>

<style scoped>
.el-select {
  width: 100%;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
.box-item .box-item-img img {
  width: 65px;
}
.table-footer {
  position: sticky;
  bottom: 0;
  background: #1a1b1c29;
  padding-top: 10px;
}
</style>
